module.exports = __webpack_public_path__ + "./BonniePhoto_e518d72ffb21d000c2ae65ff77a28782.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/BonniePhoto.png
// module id = 517
// module chunks = 0